/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo, useEffect } from 'react'
import {
  modifierCol,
  modifiedDateCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  deleteFuelCosts,
  saveFuelCosts,
  // getPFuelUnitsAtFuelCosts,
  getFuelCosts,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import {
  Button,
  DatePicker,
  // Checkbox,
  InputNumber,
  Select,
  message,
} from 'antd'

import { ErrorContext, PNodeZoneContext } from 'context'
import * as Actions from 'core/EventActions'
import CommonScreen from 'admin/component/CommonScreen'
// import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import { getPFuelCodeAtFuelCosteByClients } from 'marginanalysis/utils'

const title = 'Fuel Costs'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const FuelCostheaders = [
  unitIdHeader,
  // strCol({
  //   ident: 'unitId',
  //   display: 'Unit Id',
  //   isKey: true,
  //   sortOrder: 'asc',
  // }),
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pFuelCode',
    display: 'Primary Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(pFuelCodeChioce),
  }),
  numCol({
    ident: 'fuelCost',
    display: 'Fuel Cost',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const FuelCosts = ({ targetInfo, envConfig, actionPermits, ...props }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const [pFuelCodeMap, setPFuelCodeMap] = useState()
  // const [unitlist, setUnitList] = useState([])

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow style={{ paddingLeft: '0px' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '40px 250px 100px 150px 80px 150px 70px 150px auto auto auto',
          gridGap: '5px',
        }}
      >
        <Label>Unit :</Label>
        <div style={{ gridColumn: 'span 1' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
            showX2X3
          />
        </div>
        <Label>Effective Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>PFuel Code :</Label>
        <Select
          value={insertData.pFuelCode}
          onChange={value => setInsertData({ ...insertData, pFuelCode: value })}
          style={{ width: '100%' }}
        >
          {Object.keys(pFuelCodeMap).map(m => (
            <Select.Option key={m} value={m}>
              {m === pFuelCodeMap[m] ? m : m + ' - ' + pFuelCodeMap[m]}
            </Select.Option>
          ))}
        </Select>
        <Label>Fuel Cost:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.fuelCost}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, fuelCost: value })}
        />
        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  useEffect(
    _ => {
      getPFuelCodeAtFuelCosteByClients({
        targetInfo,
        setError,
        setPFuelCodeMap,
        CLIENT: envConfig.clientId,
      })
      // getPFuelUnitsAtFuelCosts(targetInfo).fork(setError, data => {
      //   setUnitList(data)
      // })
    },
    [envConfig.clientId, setError, targetInfo]
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate.format('YYYY-MM-DD'),
      pcodes: selcodes.includes('ALL') ? Object.keys(pFuelCodeMap) : selcodes,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  const [selcodes, setSelCodes] = useState(['ALL'])

  const headerWithFormatter = FuelCostheaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,

          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const screenCriteria = _ => {
    return (
      <CriteriaRow
        style={{
          marginTop: '5px',
          display: 'grid',
          gridTemplateColumns: '150px 1fr',
        }}
      >
        <div>Select Fuel Type : </div>
        <Select
          value={selcodes}
          onChange={setSelCodes}
          style={{ width: '100%' }}
          allowClear
          mode="multiple"
          placeholder="Select Fuel Type"
        >
          <Select.Option key="ALL" value="ALL">
            ALL
          </Select.Option>
          {Object.keys(pFuelCodeMap || {}).map(p => (
            <Select.Option key={p} value={p}>
              {p === pFuelCodeMap[p] ? p : p + '-' + pFuelCodeMap[p]}
            </Select.Option>
          ))}
        </Select>
      </CriteriaRow>
    )
  }

  // writeEventActionPermission ? (
  //   <React.Fragment>
  //     <Checkbox
  //       css={{ marginLeft: '10px', minWidth: '100px' }}
  //       onChange={e => setEditMode(e.target.checked)}
  //       checked={editMode}
  //     >
  //       Edit Mode
  //     </Checkbox>
  //     <Filler />
  //   </React.Fragment>
  // ) : (
  //   <div />
  // )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }

  const beforeRetrieveValidation = _ => {
    if (selcodes.length <= 0) {
      message.warning('Please, Select Fuel Type')
      return false
    }
    return true
  }

  return (
    <CommonScreen
      // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      withUnitSelection
      extraUnitSelectionProps={extraUnitSelectionProps}
      beforeRetrieveValidation={beforeRetrieveValidation}
      extraCriteria={screenCriteria}
      withoutModify={!writeEventActionPermission}
      withDelete={!writeEventActionPermission}
      allowInsert={writeEventActionPermission}
      isEditableGrid={isEditableGrid}
      withDatePickerTitle="Effective Date : "
      autoRetrieve={false}
      isAdminScreen={false}
      withCriteria={withCriteria}
      withDatePicker
      title={title}
      header={headerWithFormatter}
      saveTask={saveFuelCosts}
      retrieveTask={getFuelCosts}
      deleteTask={deleteFuelCosts}
      altBy={u => u.pFuelCode}
      sortOptions={FuelCostheaders}
      initialSortOptions={FuelCostheaders}
      widthOffset={50}
      insertComp={insertEvent && insertComp}
      insertCompHeight={120}
      //       heightOffset={insertEvent && insertComp ? 450 : 300}
      onInsertEvent={b => setInsertEvent(b)}
      // withImport
      // importUrl="marginanalysisdata-import/generic-import"
      // importData={{ importType: 'MA_FUEL_COST' }}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(FuelCosts)
